
// SVG Icon: previous
export default { id: "terriajs-previous" };
export const id = "terriajs-previous";
export const name = "previous";
